export const ENV = {
  API_HOST: "PUBLIC_API_HOST",
  SHOW_VOD: "PUBLIC_SHOW_VOD",
  // API_HOST: "https://api.tctv.ge/",
  // API_HOST: "https://api.inorain.tv/",
  // API_HOST: "https://api.tivimivi.net/",
  // SHOW_VOD: true,

  SENTRY_DSN:
    "https://99e84ecc0da8fa067cca31cc3be0fb36@o4510827114659840.ingest.de.sentry.io/4510827152736336", // Add your Sentry DSN here from https://sentry.io
  SENTRY_ENVIRONMENT: "production",
};
